import CustomSocialButton from '@/app/components/forms/theme-elements/CustomSocialButton';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { signInType } from '@/app/(BackOffice)/types/auth/auth';
import { signIn } from 'next-auth/react';

const AuthSocialButtons = ({ title }: signInType) => (
  <>
    <Grid container spacing={3} sx={{ mb: 6, mt: 2 }}>
      <Grid item xs={12} sm={12}>
        <CustomSocialButton fullWidth color="primary" onClick={() => signIn('azure-ad')}>
          <Avatar
            src={'/images/auth/azure2.png'}
            alt={'icon1'}
            sx={{
              width: 30,
              height: 30,
              borderRadius: 0,
              mr: 1,
            }}
          />
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              whiteSpace: 'nowrap',
              mr: { sm: '3px' },
            }}
          >
            {title}
          </Box>
          Microsoft Azure
        </CustomSocialButton>
      </Grid>
    </Grid>
  </>
);

export default AuthSocialButtons;
